import { Pages } from '../pages';
import { cacheGet } from './cacheManager';

//import moment from './moment';

// var cachedClaims = {
//   claims: null,
//   expires: moment().add(3, 'm')
// }

const grantedPerms = {
    canView: true,
    canDelete: true,
    canGetRecord: true,
    canInsert: true,
    canUpdate: true,
    canList: true,
    canExport: true,
    canImport: true,
}

const deniedPerms = {
    canView: false,
    canDelete: false,
    canGetRecord: false,
    canInsert: false,
    canUpdate: false,
    canList: false,
    canExport: false,
    canImport: false,
}

function getPermissions(resourceCode, authorizationClaims) {
    try {
        //return grantedPerms; // Bu geliştirme aşaması için
        if (resourceCode == null) return deniedPerms;

        var claims = authorizationClaims || cacheGet('authorizationClaims');
        if (claims == null)
            return deniedPerms;

        // if (cachedClaims.claims && cachedClaims.expires > moment())
        //   claims = cachedClaims.claims
        // else {
        //   claims = localStorage.getItem('authorizationClaims');
        //   if (claims == null) return deniedPerms;
        //   claims = JSON.parse(claims);
        //   cachedClaims = {
        //     claims,
        //     expires: moment().add(3, 'm')
        //   };
        //   console.warn('Permissions cached !')
        // }

        claims = claims[resourceCode];
        if (claims == null) return deniedPerms;

        return { ...deniedPerms, ...GetActionTypesOf(claims) };
    } catch (error) {
        return deniedPerms;
    }
}

function getPermissionsMultiple(resourceCodes) {
    var claims = cacheGet('authorizationClaims');
    return resourceCodes.map(resourceCode => getPermissions(resourceCode, claims))
}

function GetActionTypesOf(claim) {
    return {
        canView: claim.View,
        canList: claim.List,
        canGetRecord: claim.GetRecord,
        canInsert: claim.Insert,
        canUpdate: claim.Update,
        canDelete: claim.Delete,
        canExport: claim.Export,
        canImport: claim.Import,
    }
}

function isGranted(resourceCode) {
    try {
        var permissions = getPermissions(resourceCode);
        //permissions = permissions[action];
        if (permissions == null) return deniedPerms;

        return permissions;
    } catch (error) {
        return deniedPerms;
    }
}

function isGrantedAsPage(pageUrl) {
    try {
        var pageInfo = null;

        for (var page in Pages) {
            if (Pages[page].url == pageUrl) {
                pageInfo = Pages[page];
                break;
            }
        }

        if (pageInfo == null) return grantedPerms;
        else return isGranted(pageInfo.resourceCode);
    } catch (error) {
        console.warn(error);
        return deniedPerms;
    }
}

function getFirstAuthorizedPageUrl() {
    try {
        var authorizedPageKey = getFirstAuthorizedPageKey();
        if (authorizedPageKey)
            return Pages[authorizedPageKey].url;
    } catch (error) {
        console.error(error);
    }
    return "401";
}

function getFirstAuthorizedPageKey() {
    try {
        for (var pageKey in Pages) {
            var page = Pages[pageKey];
            if (page && page.url) {
                var isAuthorized = isGranted(page.resourceCode);
                if (isAuthorized.canView)
                    return pageKey;
            }
        }
    } catch (error) {
        console.error(error);
    }
    return null;
}

export function checkIfPageExistAndGranted(url) {
    try {
        for (var pageKey in Pages) {
            var page = Pages[pageKey];
            if (page && page.url && page.url == url) {
                var isAuthorized = isGranted(page.resourceCode);
                if (isAuthorized.canView)
                    return page.url;
            }
        }
        return null;
    } catch (e) {
        console.log(e);
    }
}

/**
 *Mainly used to indicate which page will be used for default page after login
 *
 * @return {*} 
 */
function getAllGrantedPagesForDropdown() {
    try {
        const dropdownOptions = [];
        for (let pageKey in Pages) {
            let page = Pages[pageKey];
            if (page && page.url) {
                dropdownOptions.push({
                    key: page.url,
                    value: page.url,
                    label: page.name
                });
            }
        }
        return dropdownOptions;
    } catch (e) {
        console.log(e);
    }
    return null;
}

export { isGranted, isGrantedAsPage, getPermissions, getPermissionsMultiple, getFirstAuthorizedPageUrl, getFirstAuthorizedPageKey, getAllGrantedPagesForDropdown };